/**
 * @copyright 2019 @ DigiNet
 * @author KIMLONG
 * @create 2019/01/18 15:37
 * @update 2019/01/18 15:37
 * @file src/reducers/w17F1002.js
 */

import * as types from '../actions/types.js';

const initialState = {
    sendMail:null,
    saveMail:null,
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W17_W17F1002_SENDMAIL_COMPLETE:
            return {
                ...state,
                sendMail: action.sendMail
            };
            case types.W17_W17F1002_SAVEMAIL_COMPLETE:
            return {
                ...state,
                saveMail: action.saveMail
            };


        default:
            return state;
    }
}